<h2 mat-dialog-title>Gestion des départements</h2>
<mat-dialog-content>
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
        <div fxFlex="50%">
            <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
                <div fxFlex="50%">
                    <mat-form-field class="field-full-width">
                        <mat-label>Nom du nouveau département</mat-label>
                        <input matInput [(ngModel)]="newdepartment">
                    </mat-form-field>                    
                </div>
                <div fxFlex="50%">
                    <button mat-flat-button color="primary" (click)="addDepartment()">Ajouter</button>
                </div>
            </div>
            <app-user-department-list (selected)="selectDepartment($event)"></app-user-department-list>
        </div>
        <div fxFlex="50%">
            <app-department [department]="department"></app-department>
            <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
                <div fxFlex="80%">
                    <app-user-selection (selected)="selectUser($event)" [mode]="'admin'"></app-user-selection>
                </div>
                <div fxFlex="200px">
                    <button mat-flat-button color="primary" (click)="addUser()">Ajouter</button>
                </div>
            </div>
            <app-user-list (remove)="removeUser($event)" [users]="departmentUsers" [mode]="'summary'" [actions]="['remove']"></app-user-list>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Fermer</button>
</mat-dialog-actions>